export default __webpack_public_path__ + "static/media/Express-wear-400x482.0380d3fb.png";